export const authSocialErrorHandbook = {
  default: 'Что-то пошло не так. Пожалуйста, попробуйте ещё раз',
  alreadyLinked: 'Аккаунт уже привязан к другому профилю',
  email: {
    default: 'Допущена ошибка в электронной почте',
    required: 'Введите свою электронную почту',
    email: 'Электронная почта введена неверно',
  },
  password: {
    default: 'Допущена ошибка при вводе пароля',
    required: 'Введите пароль',
    error: 'Пароль введен неверно',
  },
}
